import React from 'react';
import { EMPRESA, LEGAL_LAST_UPDATE } from '../../lib/legal';

const H = ({ children }) => (
  <h3 className="text-base font-bold text-slate-900 mt-6 mb-2">{children}</h3>
);

const Terminos = () => (
  <div data-testid="terminos-content">
    <p className="text-xs text-slate-500 uppercase tracking-wider">
      Última actualización: {LEGAL_LAST_UPDATE}
    </p>
    <p>
      Estos Términos y Condiciones regulan el uso del sitio web{' '}
      <strong>{EMPRESA.sitio}</strong> y de la plataforma SaaS{' '}
      <strong>{EMPRESA.plataforma}</strong> (en adelante, &quot;PreventiApp&quot;), servicios operados
      por <strong>{EMPRESA.razonSocial}</strong>, RUT {EMPRESA.rut}, con domicilio en
      {' '}{EMPRESA.direccion}.
    </p>

    <H>1. Aceptación</H>
    <p>
      Al acceder al sitio o usar la plataforma, aceptas estos términos, la Política de
      Privacidad y las normas legales aplicables en la República de Chile. Si no estás de
      acuerdo, por favor no utilices el servicio.
    </p>

    <H>2. Descripción del servicio</H>
    <p>
      PreventiApp es un <strong>Centro de Inteligencia Preventiva Escolar</strong>: una
      plataforma SaaS que permite a establecimientos educacionales registrar observaciones
      conductuales, gestionar la trazabilidad preventiva y obtener indicadores agregados de
      convivencia escolar. El servicio se presta en modalidad de suscripción a colegios y
      redes educativas.
    </p>

    <H>3. Cuentas y roles</H>
    <p>
      El acceso al SaaS requiere autenticación. Los usuarios finales (docentes, inspectores,
      orientadores, encargados de convivencia, directivos, administradores) actúan en
      representación del establecimiento contratante. El colegio es responsable de la
      correcta asignación de roles y del uso adecuado por parte de su personal.
    </p>

    <H>4. Uso adecuado</H>
    <ul className="list-disc pl-5 space-y-1">
      <li>No usar el servicio para fines ilícitos o contrarios a la moral y el orden público.</li>
      <li>No cargar contenidos de terceros sin autorización.</li>
      <li>Cumplir con la obligación de <strong>anonimización de rostros</strong> en evidencias
        fotográficas: la plataforma pixela automáticamente los rostros detectados antes de
        cualquier almacenamiento. No intentar eludir esta protección.</li>
      <li>Respetar la confidencialidad de los datos de niños, niñas y adolescentes.</li>
    </ul>

    <H>5. Propiedad intelectual</H>
    <p>
      La marca, logotipos, diseños, código fuente, textos, gráficos e imágenes del sitio y de
      la plataforma son propiedad de {EMPRESA.razonSocial} o de sus licenciantes, y están
      protegidos por la Ley N° 17.336 de Propiedad Intelectual. Se prohíbe su reproducción o
      uso sin autorización expresa.
    </p>

    <H>6. Titularidad y tratamiento de datos</H>
    <p>
      Los datos ingresados por los establecimientos educacionales son de titularidad de los
      titulares de dichos datos (estudiantes, apoderados, funcionarios). El colegio actúa
      como <strong>responsable del tratamiento</strong> y PreventiApp como{' '}
      <strong>encargado del tratamiento</strong>. Para más información revisa nuestra
      Política de Privacidad.
    </p>

    <H>7. Disponibilidad y suspensión</H>
    <p>
      Nos esforzamos por mantener el servicio disponible 24/7, pero pueden producirse
      interrupciones por mantenimiento, actualizaciones o causas de fuerza mayor. No
      garantizamos disponibilidad ininterrumpida ni ausencia total de errores. Los SLA
      específicos se definen en los contratos con cada establecimiento suscrito.
    </p>

    <H>8. Limitación de responsabilidad</H>
    <p>
      PreventiApp no será responsable por daños indirectos, lucro cesante o consecuencias
      derivadas del uso o imposibilidad de uso del servicio, salvo culpa grave o dolo. La
      responsabilidad máxima acumulada se limita al monto efectivamente pagado por el cliente
      en los 12 meses anteriores al hecho generador del reclamo.
    </p>

    <H>9. Modificaciones</H>
    <p>
      Podemos modificar estos términos publicando la nueva versión con al menos 30 días de
      anticipación. El uso continuado del servicio después de la fecha de vigencia se
      considera aceptación de los términos modificados.
    </p>

    <H>10. Terminación</H>
    <p>
      Podemos suspender o terminar cuentas que incumplan estos términos. En caso de
      terminación, los datos del establecimiento se conservarán por 12 meses en respaldo
      seguro y luego se eliminarán en forma permanente, salvo obligación legal contraria.
    </p>

    <H>11. Ley aplicable y jurisdicción</H>
    <p>
      Estos términos se rigen por las leyes de la <strong>República de Chile</strong>.
      Cualquier controversia será sometida a los <strong>Tribunales Ordinarios de Justicia
      de Santiago</strong>, sin perjuicio del derecho de los consumidores establecido en la
      Ley N° 19.496 sobre Protección de los Derechos de los Consumidores.
    </p>

    <H>12. Contacto</H>
    <p>
      Consultas contractuales: {' '}
      <a href={`mailto:${EMPRESA.emailGeneral}`} className="text-brand-violet underline">
      {EMPRESA.emailGeneral}</a><br />
      Consultas de privacidad:{' '}
      <a href={`mailto:${EMPRESA.emailPrivacidad}`} className="text-brand-violet underline">
      {EMPRESA.emailPrivacidad}</a>
    </p>
  </div>
);

export default Terminos;
